import React, { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import Navigation from "../Footer/Navigation";
import NavigationModal from "../Modals/NavigationModal";

const Layout = ({ children, setLocale }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { isLoggedIn, userRole, userEmail, logout } = useAuth();

  const showModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="layout">
      <Navbar
        isLoggedIn={isLoggedIn}
        userRole={userRole}
        userEmail={userEmail}
        onLogout={logout}
        setLocale={setLocale}
      />

      {/* Sekcja główna */}
      <div className="main-content">
        <main className="content">{children}</main>
      </div>

      {/* Modal z Navigation */}
      <NavigationModal isOpen={isModalOpen} onClose={closeModal}>
        <Navigation />
      </NavigationModal>

      <Footer showModal={showModal} closeModal={closeModal} />
    </div>
  );
};

export default Layout;
